document.addEventListener('DOMContentLoaded', () => {
  const countryInputs = document.querySelectorAll('.input-wrapper--drop-down')

  if (countryInputs) {
    countryInputs.forEach(countryInput => {
      const input = countryInput.querySelector('.input-wrapper__input')
      const countryInner = countryInput.querySelector('.input-wrapper__inner')
      const countryList = countryInput.querySelector('.input-wrapper__list')
      const countryButtons = countryInput.querySelectorAll('.input-wrapper__button')

      if (input && countryButtons && countryList) {
        let timeout

        let selected = false

        input.addEventListener('input', () => {
          clearTimeout(timeout)
          timeout = setTimeout(() => {
            selected = false
            let result = 0
            countryButtons.forEach(button => {
              const country = button.getAttribute('data-country').toLowerCase().trim()
              if (country.indexOf(input.value.toLowerCase()) === 0 && input.value.toLowerCase() !== country) {
                result++
                button.classList.remove('input-wrapper__button--not-view')
                return
              }
              if(country === input.value.toLowerCase()) {
                selected = true
              }
              button.classList.add('input-wrapper__button--not-view')
            })
            result > 0 ? countryInner.classList.remove('input-wrapper__inner--empty') : countryInner.classList.add('input-wrapper__inner--empty')
          }, 500)
        })

        input.addEventListener('focus', () => {
          if(selected) {
            countryButtons.forEach(button => {
              button.classList.remove('input-wrapper__button--not-view')
              countryInner.classList.remove('input-wrapper__inner--empty')
            })
          }
        })

        countryButtons.forEach(button => {
          const country = button.getAttribute('data-country')
          button.addEventListener('click', () => {
            input.value = country
            input.setAttribute('value', country)
            input.dispatchEvent(new Event('input'))
            input.blur()
            selected = button
          })
        })
      }
    })
  }
})
